import { render } from "./Paging.vue?vue&type=template&id=2d9901e1&scoped=true"
import script from "./Paging.vue?vue&type=script&lang=js"
export * from "./Paging.vue?vue&type=script&lang=js"

import "./Paging.vue?vue&type=style&index=0&id=2d9901e1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9901e1"]])

export default __exports__